export const currencyFormatter = new Intl.NumberFormat(undefined, {
    currency: "gbp",
    style: "currency",
    minimumFractionDigits: 0,
})